<script setup lang="ts">
import { formatFriendlyTime } from '@/utils/time'
import { currentLang } from '@/composables/settings/storage'
import type { PropType } from 'vue'
import type { Name } from '@/composables/user/users'
import type { RelationDTO } from '@/composables/memorize/memorize'
import { cutText } from '@/utils/util'

const props = defineProps({
  creatorName: {
    type: Object as PropType<Name | null>,
    default: '',
    required: true
  },
  createTime: {
    type: Number,
    required: true,
    default: 0
  },
  creatorRelation: {
    type: Object as PropType<RelationDTO>,
    required: false,
    default: null
  },
  updaterName: {
    type: Object as PropType<Name | null>,
    required: false,
    default: null
  },
  updateTime: {
    type: Number,
    required: false,
    default: 0
  },
  updaterRelation: {
    type: Object as PropType<RelationDTO | null>,
    required: false,
    default: null
  }
})
</script>
<template>
  <div text-sm truncate>
    <div flex="~ row" mt-0.5 items-baseline v-if="props.updaterName === null">
      <p pr-3 text-theme-dark truncate>
        {{ cutText(props?.creatorName?.fullName || '', 10)
        }}<span v-if="props.creatorRelation" ml-1 text-third>({{ props.creatorRelation?.name }})</span>
      </p>
      <p text-theme-gray v-if="props.createTime > 0" truncate>
        {{ formatFriendlyTime(props?.createTime, currentLang || 'zh_CN') }}
      </p>
    </div>
    <div flex="~ row" mt-0.5 items-baseline v-else>
      <p pr-2 text-theme-dark truncate>
        {{ cutText(props?.updaterName.fullName, 10)
        }}<span v-if="props.updaterRelation" ml-1 text-third>({{ props.updaterRelation?.name }})</span>
      </p>
      <p text-theme-gray v-if="props.updateTime > 0" truncate>
        {{ $t('m.edit_by_time', { time: formatFriendlyTime(props?.updateTime, currentLang || 'zh_CN', false, true) }) }}
      </p>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
